import { render, staticRenderFns } from "./rmas_section.vue?vue&type=template&id=053d7798&"
import script from "./rmas_section.vue?vue&type=script&lang=js&"
export * from "./rmas_section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports